import React from "react";
import { connectStateResults } from "react-instantsearch-dom";

type HasHitsProps = {
  searchResults?: { nbHits: number };
  children?: React.ReactNode;
};

// Show wrapped content only if there are any search hits
const HasHits: React.FunctionComponent<any> = (props): JSX.Element | null => {
  const { searchResults, children }: HasHitsProps = props;
  const hasResults = searchResults && searchResults.nbHits !== 0;

  if (hasResults) {
    return <>{children}</>;
  }
  return null;
};

export default connectStateResults(HasHits);
